import React from "react";

const StripeSettingsContext = React.createContext();

StripeSettingsContext.displayName = "StripeSettingsContext";

export default StripeSettingsContext;
